<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify"></i> Email configuration
          </div>
          <div class="card-block">
            <div class="row">
              <div class="col-md-4">
              <label>Monday email template</label>
              <select v-model="worklogEmailTemplate" class="form-control">
                <option :value="template.id" v-for="template in templates_dropdown">{{template.contract_name}}</option>
              </select>
              </div>
              <div class="col-md-4">
                <label>Recipient</label><input class="form-control" type="text" v-model="worklogEmailRecipient">
              </div>
              <div class="col-md-4">
                <label>Group</label>
                <select v-model="worklogEmailGroup" class="form-control">
                  <option :value="group.id" v-for="group in groups">{{group.name}}</option>
                </select>
              </div>
            </div>
            <br>
            <button class="btn btn-primary" @click="updateConfigWeekWorklog">Update</button>
            <button class="btn btn-success" @click="sendTestMail({'template': worklogEmailTemplate, 'recipient': worklogEmailRecipient, 'group': worklogEmailGroup, prefix: 'worklog', test: true})">Send</button>
            <button class="btn btn-success" @click="sendTestMail({'template': worklogEmailTemplate, 'recipient': worklogEmailRecipient, 'group': worklogEmailGroup, prefix: 'worklog', test: false})">Send to all</button>
          </div>
          <div class="card-block">
            <div class="row">
              <div class="col-md-4">
              <label>Friday email template</label>
              <select v-model="fridayEmailTemplate" class="form-control">
                <option :value="template.id" v-for="template in templates_dropdown">{{template.contract_name}}</option>
              </select>
              </div>
              <div class="col-md-4">
                <label>Recipient</label><input class="form-control" type="text" v-model="fridayEmailRecipient">
              </div>
              <div class="col-md-4">
                <label>Group</label>
                <select v-model="fridayEmailGroup" class="form-control">
                  <option :value="group.id" v-for="group in groups">{{group.name}}</option>
                </select>
              </div>
            </div>
            <br>
            <button class="btn btn-primary" @click="updateConfigWeekFriday">Update</button>
            <button class="btn btn-success" @click="sendTestMail({'template': fridayEmailTemplate, 'recipient': fridayEmailRecipient, 'group': fridayEmailGroup, prefix: 'friday', test: true})">Send</button>
            <button class="btn btn-success" @click="sendTestMail({'template': fridayEmailTemplate, 'recipient': fridayEmailRecipient, 'group': fridayEmailGroup, prefix: 'friday', test: false})">Send to all</button>
          </div>
          <div class="card-block">
            <div class="row">
              <div class="col-md-4">
                <label>First day of month template</label>
                <select v-model="firstDayOfMonthEmail.template" class="form-control">
                  <option :value="template.id" v-for="template in templates_dropdown">{{template.contract_name}}</option>
                </select>
              </div>
              <div class="col-md-4">
                <label>Recipient</label><input class="form-control" type="text" v-model="firstDayOfMonthEmail.recipient">
              </div>
              <div class="col-md-4">
                <label>Group</label>
                <select v-model="firstDayOfMonthEmail.group" class="form-control">
                  <option :value="group.id" v-for="group in groups">{{group.name}}</option>
                </select>
              </div>
            </div>
            <br>
            <button class="btn btn-primary" @click="updateConfigFirstMonthDay">Update</button>
            <button class="btn btn-success" @click="sendTestMail({'template': firstDayOfMonthEmail.template, 'recipient': firstDayOfMonthEmail.recipient, 'group': firstDayOfMonthEmail.group, prefix: 'firstDayOfMonth', test: true})">Send</button>
            <button class="btn btn-success" @click="sendTestMail({'template': firstDayOfMonthEmail.template, 'recipient': firstDayOfMonthEmail.recipient, 'group': firstDayOfMonthEmail.group, prefix: 'firstDayOfMonth', test: false})">Send to all</button>
          </div>
          <div class="card-block">
            <div class="row">
              <div class="col-md-4">
                <label>Last day of month template</label>
                <select v-model="lastDayOfMonthEmail.template" class="form-control">
                  <option :value="template.id" v-for="template in templates_dropdown">{{template.contract_name}}</option>
                </select>
              </div>
              <div class="col-md-4">
                <label>Recipient</label><input class="form-control" type="text" v-model="lastDayOfMonthEmail.recipient">
              </div>
              <div class="col-md-4">
                <label>Group</label>
                <select v-model="lastDayOfMonthEmail.group" class="form-control">
                  <option :value="group.id" v-for="group in groups">{{group.name}}</option>
                </select>
              </div>
            </div>
            <br>
            <button class="btn btn-primary" @click="updateConfigLastMonthDay">Update</button>
            <button class="btn btn-success" @click="sendTestMail({'template': lastDayOfMonthEmail.template, 'recipient': lastDayOfMonthEmail.recipient, 'group': lastDayOfMonthEmail.group, prefix: 'lastDayOfMonth', test: true})">Send</button>
            <button class="btn btn-success" @click="sendTestMail({'template': lastDayOfMonthEmail.template, 'recipient': lastDayOfMonthEmail.recipient, 'group': lastDayOfMonthEmail.group, prefix: 'lastDayOfMonth',  test: false})">Send to all</button>
          </div>
        </div>
      </div><!--/.col-->
    </div><!--/.row-->
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify"></i> Planned period recalculate
          </div>
          <div class="card-block">
            <div class="row">
              <div class="col-md-6">
                <label>Start date</label>
                <datepicker placeholder="yyyy-mm-dd" input-class="audit-logs-date-picker" :disabled-dates="{from: new Date(recalculatePeriod.end)}" v-model="recalculatePeriod.start" format="yyyy-MM-dd"></datepicker>
              </div>
              <div class="col-md-6">
                <label>End date</label>
                <datepicker placeholder="yyyy-mm-dd" input-class="audit-logs-date-picker" :disabled="!recalculatePeriod.start" :disabled-dates="{to: new Date(recalculatePeriod.start)}" v-model="recalculatePeriod.end" format="yyyy-MM-dd"></datepicker>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <label>User</label>
                <select v-model="recalculatePeriod.userId" class="form-control">
                  <option :value="null">All active users</option>
                  <option v-for="user in activeUsers" :value="user.id">{{user.displayName}}</option>
                </select>
              </div>
              <div class="col-md-6">
                <label>Project</label>
                <select v-model="recalculatePeriod.projectId" class="form-control">
                  <option :value="null">All projects</option>
                  <option v-for="project in projects" :value="project.id">{{project.name}}</option>
                </select>
              </div>
            </div>
            <div class="mt-1">
              <button @click="recalculatePlannedPeriod" class="btn btn-primary">Recalculate</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify"></i> Set Active users group
          </div>
          <div class="card-block">
              <div class="form-group row">
                <label class="pl-1 form-control-label">Group</label>
                <div class="col-md-3">
                  <select v-model="selectedActiveUserGroup.id" class="form-control">
                    <option :value="null">All groups</option>
                    <option v-for="group in groups" :value="group.id">{{group.name}}</option>
                  </select>
                </div>
                <div class="col-md-1 pl-0">
                  <button @click="setActiveUsersGroup()" class="btn btn-primary">Set group</button>
                </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-header">
            <i class="fa fa-align-justify"></i> Audit Logs
          </div>
          <div class="card-block">
            <!--<button class="btn btn-primary action-button" @click="resetWorklogs">Reset worklogs</button>-->
            <table class="table table-bordered table-striped table-condensed">
              <thead>
              <tr>
                <th>#</th>
                <th>Category</th>
                <th>Data</th>
                <th>Details</th>
                <th>Logged at</th>
              </tr>
              </thead>
              <tbody>
                <tr v-for="auditLog in last10Logs">
                    <td>{{auditLog.id}}</td>
                    <td>{{auditLog.category}}</td>
                    <td>{{auditLog.data}}</td>
                    <td class="details">{{auditLog.details}}</td>
                    <td>{{auditLog.logged_at}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div><!--/.col-->
    </div><!--/.row-->
  </div>
</template>
<style lang="scss" scoped>
    .details{
        word-break: break-all;
    }
    .action-button{
        margin-bottom: 10px;
    }
    th, td {
      padding: 0;
    }
    tbody > tr:hover {
      background-color: #c8d2d2;
    }
</style>
<style>
  .audit-logs-date-picker {
    width: 100%;
    border: 1px solid rgba(0, 0, 0, 0.15);
    color: #607d8b;
    padding: 0.5rem 0.75rem;
  }
</style>

<script>

import { mapGetters, mapActions } from 'vuex';
import VueNotifications from 'vue-notifications';
import moment from 'moment';
import Datepicker from 'vuejs-datepicker';
import { Backend } from '@/_axios';

export default {
  name: 'AuditLogs',
  components: {
    Datepicker
  },
  data: function () {
    return {
      worklogEmailTemplate: null,
      worklogEmailRecipient: null,
      worklogEmailGroup: null,
      fridayEmailTemplate: null,
      fridayEmailRecipient: null,
      fridayEmailGroup: null,
      firstDayOfMonthEmail: {
        template: null,
        recipient: null,
        group: null
      },
      lastDayOfMonthEmail: {
        template: null,
        recipient: null,
        group: null
      },
      recalculatePeriod: {
        start: moment().format('YYYY-MM-DD'),
        end: moment().add(1, 'months').format('YYYY-MM-DD'),
        projectId: null,
        userId: null
      },
      selectedActiveUserGroup: {
        id: null,
        name: ''
      }
    };
  },
  watch: {
    configurations() {
      this.worklogEmailTemplate = this.configurations['worklogEmailTemplate'] || null;
      this.worklogEmailRecipient = this.configurations['worklogEmailRecipient'] || null;
      this.worklogEmailGroup = this.configurations['worklogEmailGroup'] || null;

      this.fridayEmailTemplate = this.configurations['fridayEmailTemplate'] || null;
      this.fridayEmailRecipient = this.configurations['fridayEmailRecipient'] || null;
      this.fridayEmailGroup = this.configurations['fridayEmailGroup'] || null;

      this.firstDayOfMonthEmail.template = this.configurations['firstDayOfMonthEmailTemplate'] || null;
      this.firstDayOfMonthEmail.recipient = this.configurations['firstDayOfMonthEmailRecipient'] || null;
      this.firstDayOfMonthEmail.group = this.configurations['firstDayOfMonthEmailGroup'] || null;

      this.lastDayOfMonthEmail.template = this.configurations['lastDayOfMonthEmailTemplate'] || null;
      this.lastDayOfMonthEmail.recipient = this.configurations['lastDayOfMonthEmailRecipient'] || null;
      this.lastDayOfMonthEmail.group = this.configurations['lastDayOfMonthEmailGroup'] || null;
    },
    activeUsersGroup: {
      handler: function (val) {
        if (this.activeUsersGroup) {
          this.selectedActiveUserGroup = this.activeUsersGroup;
        }
      },
      deep: true
    },
    groupNotification: {
      handler: function (val) {
        if (this.groupNotification.status == 'success') {
          this.showSuccessMsg({ title: 'Active users group status', message: this.groupNotification.message });
        }
        if (this.groupNotification.status == 'error') {
          this.showErrorMsg({ title: 'Active users group status', message: this.groupNotification.message });
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters('AuditLogs', {
      auditLogs: 'auditLogs',
    }),
    ...mapGetters('Configurations', [
      'configurations',
    ]),
    ...mapGetters('Templates', [
      'templates_dropdown',
    ]),
    ...mapGetters('Groups', [
      'groups', 'activeUsersGroup', 'groupNotification'
    ]),
    ...mapGetters('JiraUsers', ['users', 'activeUsers']),
    ...mapGetters('JiraProjects', ['projects']),
    last10Logs() {
      const logs = Object.values(this.auditLogs);
      return logs.slice(Math.max(logs.length - 10, 1));
    },

  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success
    },
    showInfoMsg: {
      type: VueNotifications.types.info
    },
    showWarnMsg: {
      type: VueNotifications.types.warn
    },
    showErrorMsg: {
      type: VueNotifications.types.error
    }
  },
  methods: {
    ...mapActions('AuditLogs', ['LOAD_AUDIT_LOGS']),
    ...mapActions('Worklogs', ['RESET_JIRA_WORKLOGS']),
    ...mapActions('Configurations', ['LOAD_CONFIGURATIONS', 'SET_CONFIGURATION']),
    ...mapActions('Templates', ['TEMPLATES_DROPDOWN']),
    ...mapActions('Groups', ['LOAD_GROUPS', 'SET_ACTIVE_USERS_GROUP', 'LOAD_ACTIVE_USERS_GROUP']),
    ...mapActions('PlannedVacations', ['RECALCULATE_PERIOD']),
    ...mapActions('JiraUsers', ['LOAD_JIRA_ACTIVE_USERS']),
    resetWorklogs() {
      this.RESET_JIRA_WORKLOGS();
      window.alert('Worklog reset scheduled!');
    },
    setConfiguration(key, value) {
      this.SET_CONFIGURATION({ key: key, value: value });
    },
    sendTestMail(data) {
      const _this = this;
      Backend.patch('/api/send-mail', data).then(
        () => {
          _this.showSuccessMsg({ title: 'Action status', message: 'Email sent' });
        },
        () => {
          _this.showErrorMsg({ title: 'Action status', message: 'Error' });
        }
      );
    },
    updateConfigWeekWorklog() {
      this.setConfiguration('worklogEmailTemplate', this.worklogEmailTemplate);
      this.setConfiguration('worklogEmailRecipient', this.worklogEmailRecipient);
      this.setConfiguration('worklogEmailGroup', this.worklogEmailGroup);
    },
    updateConfigWeekFriday() {
      this.setConfiguration('fridayEmailTemplate', this.fridayEmailTemplate);
      this.setConfiguration('fridayEmailRecipient', this.fridayEmailRecipient);
      this.setConfiguration('fridayEmailGroup', this.fridayEmailGroup);
    },
    updateConfigFirstMonthDay() {
      this.setConfiguration('firstDayOfMonthEmailTemplate', this.firstDayOfMonthEmail.template);
      this.setConfiguration('firstDayOfMonthEmailRecipient', this.firstDayOfMonthEmail.recipient);
      this.setConfiguration('firstDayOfMonthEmailGroup', this.firstDayOfMonthEmail.group);
    },
    updateConfigLastMonthDay() {
      this.setConfiguration('lastDayOfMonthEmailTemplate', this.lastDayOfMonthEmail.template);
      this.setConfiguration('lastDayOfMonthEmailRecipient', this.lastDayOfMonthEmail.recipient);
      this.setConfiguration('lastDayOfMonthEmailGroup', this.lastDayOfMonthEmail.group);
    },
    recalculatePlannedPeriod() {
      const _this = this;
      this.recalculatePeriod.start = moment(this.recalculatePeriod.start).format('YYYY-MM-DD');
      this.recalculatePeriod.end = moment(this.recalculatePeriod.end).format('YYYY-MM-DD');
      this.RECALCULATE_PERIOD(this.recalculatePeriod).then((response) => {
        _this.showSuccessMsg({ title: 'Action status', message: 'Recalculation scheduled' });
      }, (err) => {
        _this.showErrorMsg({ title: 'Action status', message: err.message });
      });
    },
    setActiveUsersGroup() {
      this.SET_ACTIVE_USERS_GROUP({ groupId: this.selectedActiveUserGroup.id });
      this.LOAD_JIRA_ACTIVE_USERS();
    }
  },
  mounted() {
    this.LOAD_AUDIT_LOGS();
    this.LOAD_CONFIGURATIONS();
    this.TEMPLATES_DROPDOWN();
    this.LOAD_GROUPS();
    this.LOAD_ACTIVE_USERS_GROUP();
  }
};
</script>
